exports.EventEmitter = require('./lib/event-emitter');
